import { useAppSelector } from '../hooks/useAppSelector';
import * as referenceSlice from '../data/reference.slice';
import vehicleUtils from '../services/vehicleUtils';

export const useVehicleType = (typeId: number | undefined): string => {
  const types = useAppSelector(referenceSlice.selectVehicleTypes);
  return vehicleUtils.getVehicleTypeName(types, typeId);
};
